import { Leaf } from "lucide-react";

const Header = () => {
  return (
    <header className="fixed top-0 w-full bg-white/95 backdrop-blur-xl border-b border-blue-100 z-50 shadow-lg" style={{backgroundColor: 'rgba(255, 251, 235, 0.95)'}}>
      {/* Scroll Progress Bar */}
      <div className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-green-400 via-emerald-400 to-green-500 scroll-progress transition-all duration-300 ease-out" style={{width: '0%'}}></div>
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <div className="p-1 bg-gradient-to-br rounded-xl">
          <img
                      src='/logo-1.svg'
                      alt='logo'
                      className="w-full h-12 object-contain group-hover:scale-120 transition-transform duration-700"
                    />
          </div>
      <div className="mb-1">

          <h1 className="text-2xl font-bold bg-gradient-to-r from-red-600 via-orange-400 to-green-500 bg-clip-text text-transparent">
            Nature's Bite
          </h1>
          <span className="bg-gradient-to-r from-red-600 via-orange-400 to-green-500 bg-clip-text text-transparent font-semibold">
                Engineers by profession, health lover by passion
          </span>
        </div>
        </div>
        
        <nav className="hidden md:flex space-x-8">
          <a href="#home" className="text-green-800 hover:text-green-600 transition-colors font-medium">Home</a>
          <a href="#menu" className="text-green-800 hover:text-green-600 transition-colors font-medium">Menu</a>
          <a href="#about" className="text-green-800 hover:text-green-600 transition-colors font-medium">About</a>
        </nav>
        {/* <button className="bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white font-semibold px-6 py-2.5 rounded-xl transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25">
          Contact Us
        </button> */}
      </div>
    </header>
  );
};

export default Header;
